import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable()
export class NetworkErrorInterceptor implements HttpInterceptor {
  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error(error);

        let uxErrorMessage = 'An unknown error occurred!';

        if (error.error.message) {
          uxErrorMessage = error.error.message;
        }

        // TODO: Add a component modal dialog or a toaster that displays error.
        // TODO: Send log to DB
        console.error(uxErrorMessage);

        if (environment.isDemo) {
          // eslint-disable-next-line no-unused-vars
          const endPoint: string = error.url.replace(
            'http://localhost.local-error-interceptor/',
            ''
          );
          // TODO: Handle specific cases
        }

        return throwError(() => error);
      })
    );
  }
}
